import { render, staticRenderFns } from "./TopNoisyUrlsWidget.vue?vue&type=template&id=418b44d8&"
import script from "./TopNoisyUrlsWidget.vue?vue&type=script&lang=js&"
export * from "./TopNoisyUrlsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports